/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { colors } from '../../styles/colors'
import Item from './components/Item'
import { StyledTab } from './styles'

interface ITabItemProps {
  href?: string
  color?: string
  placement?: string
  disabled?: boolean
  active: boolean
  onClick?(e: any): void
}

interface ITabProps {
  color?: string
  background?: string
  disabled?: boolean
  showDivider?: boolean
}

type TItemComponent = React.FunctionComponent<ITabItemProps>
type TTabComponent = React.FunctionComponent<ITabProps> & {
  Item: TItemComponent
}

const Tab: TTabComponent = ({
  color = 'blue',
  background = colors.blue,
  disabled,
  ...props
}) => {
  const renderChildren = () => {
    return React.Children.map(props.children, (item: any, index) =>
      React.cloneElement(item, {
        color,
        disabled,
        key: index,
      }),
    )
  }

  return (
    <StyledTab background={background} color={color} {...props}>
      {renderChildren()}
    </StyledTab>
  )
}

Tab.Item = Item

export default Tab
